import React from 'react';
import PropTypes from 'prop-types';
import DefaultPropTypes from '../utils/prop-types';
import FilterCollectionView from './filters/filter-collection-view';
import ChipView from './filters/chip-view';
var FilterView = function FilterView(_ref) {
  var onToggleShowFilters = _ref.onToggleShowFilters,
    filtersVisible = _ref.filtersVisible,
    filters = _ref.filters,
    onChange = _ref.onChange,
    onClearAll = _ref.onClearAll,
    dictionary = _ref.dictionary,
    isDesktop = _ref.isDesktop;
  var handleFilterButtonClick = function handleFilterButtonClick(e) {
    e.preventDefault();
    onToggleShowFilters();
  };
  var handleFilterElementChange = function handleFilterElementChange(element) {
    element.selected = !element.selected;
    onChange(element);
  };
  var handleChipCloseClick = function handleChipCloseClick(filterElement) {
    filterElement.selected = false;
    onChange(filterElement);
  };
  var handleClearAllClick = function handleClearAllClick(e) {
    e.preventDefault();
    onClearAll();
  };
  var selectedFilterElements = filters.map(function (filter) {
    return filter.elements.filter(function (element) {
      return element.selected;
    });
  }).flatten();
  return /*#__PURE__*/React.createElement("div", {
    className: "filters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "main"
  }, /*#__PURE__*/React.createElement("div", {
    className: "main__inner"
  }, /*#__PURE__*/React.createElement("button", {
    className: "button toggle-button like-white-blue-button",
    onClick: handleFilterButtonClick,
    "aria-expanded": filtersVisible,
    "aria-controls": "filters-details"
  }, /*#__PURE__*/React.createElement("span", {
    className: "toggle-button__label"
  }, dictionary.filterby)), /*#__PURE__*/React.createElement("div", {
    className: "summary-container"
  }, selectedFilterElements.map(function (el) {
    return /*#__PURE__*/React.createElement("div", {
      className: "summary-container__chip",
      key: el.id
    }, /*#__PURE__*/React.createElement(ChipView, {
      filterElement: el,
      onCloseClick: handleChipCloseClick,
      className: ""
    }));
  }), !!selectedFilterElements.length && /*#__PURE__*/React.createElement("button", {
    className: "clear-all-button",
    onClick: handleClearAllClick
  }, dictionary.viewall)))), /*#__PURE__*/React.createElement("div", {
    id: "filters-details",
    className: "details ".concat(filtersVisible ? '' : 'details--hidden'),
    hidden: !filtersVisible
  }, /*#__PURE__*/React.createElement("div", {
    className: "details__inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "collection-container"
  }, filters.map(function (filter) {
    return /*#__PURE__*/React.createElement(FilterCollectionView, {
      key: filter.id,
      filter: filter,
      onChange: handleFilterElementChange,
      isDesktop: isDesktop
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "details__footer"
  }, /*#__PURE__*/React.createElement("button", {
    className: "button close-filters-button like-white-blue-button",
    onClick: handleFilterButtonClick
  }, dictionary.closefilters)))));
};
FilterView.propTypes = {
  filtersVisible: PropTypes.bool,
  onToggleShowFilters: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  filters: PropTypes.array,
  onChange: PropTypes.func,
  onClearAll: PropTypes.func,
  dictionary: DefaultPropTypes.dictionary.isRequired,
  isDesktop: PropTypes.bool
};
FilterView.defaultProps = {
  filtersVisible: false,
  onToggleShowFilters: function onToggleShowFilters() {
    return null;
  },
  filters: [],
  onChange: function onChange() {
    return null;
  },
  onClearAll: function onClearAll() {
    return null;
  },
  isDesktop: false
};
export default FilterView;